<div class="upload_body">
  <div class="top_panel">
    <h3 mat-dialog-title>{{modalHeading[data.type]}}</h3>
    <span (click)="close()" class="close">
      <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  </div>
  <div class="formarea">
   <!-- ***** Request Form ****** -->
    
    <form [formGroup]="specialRequestForm" *ngIf="data.type === 'request'">
      <div class="inputprt">
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Request Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="New">New</mat-option>
            <mat-option value="Hold">Hold</mat-option>
            <mat-option value="Processing">Processing</mat-option>
            <mat-option value="Completed">Completed</mat-option>
          </mat-select>
          <mat-error  *ngIf="specialRequestForm.controls['status'].touched && specialRequestForm.controls['status'].hasError('required')">
              This is required field.
          </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="auto" appearance="outline">
        <mat-label>Agreement Number</mat-label>
        <input matInput placeholder="Agreement Number" formControlName="agreementNumber">
    </mat-form-field>
    <mat-form-field fxFlex="auto" appearance="outline">
      <mat-label>Request Type</mat-label>
      <mat-select formControlName="type">
        <mat-option value="Update Information">Update Information</mat-option>
        <mat-option value="Update Effective Date">Update Effective Date</mat-option>
        <mat-option value="Update Payment">Update Payment</mat-option>
        <mat-option value="Update Billing Date">Update Billing Date</mat-option>
        <mat-option value="Email Agreement">Email Agreement</mat-option>
        <mat-option value="Mail Hard Copy">Mail Hard Copy</mat-option>
        <mat-option value="Cancellation">Cancellation</mat-option>
        <mat-option value="Referral Bonus">Referral Bonus</mat-option>
        <mat-option value="Refund">Refund</mat-option>
        <mat-option value="Claim Update">Claim Update</mat-option>
        <mat-option value="Claim Payout">Claim Payout</mat-option>
        <mat-option value="Claim Dispute">Claim Dispute</mat-option>
        <mat-option value="Other">Other</mat-option>
      </mat-select>
      <mat-error  *ngIf="specialRequestForm.controls['type'].touched && specialRequestForm.controls['type'].hasError('required')">
          This is required field.
      </mat-error>
  </mat-form-field>
  <mat-form-field fxFlex="auto" appearance="outline">
    <mat-label>Priority</mat-label>
    <mat-select formControlName="priority">
      <mat-option value="Low">Low</mat-option>
      <mat-option value="Medium">Medium</mat-option>
      <mat-option value="High">High</mat-option>
      <mat-option value="Critical">Critical</mat-option>
    </mat-select>
    <mat-error  *ngIf="specialRequestForm.controls['priority'].touched && specialRequestForm.controls['priority'].hasError('required')">
        This is required field.
    </mat-error>
</mat-form-field>
<mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
  <mat-label>Assigned</mat-label>
  <input type="text"
         placeholder="Assigned"
         aria-label="Assigned"
         matInput
         formControlName="assigned"
         [matAutocomplete]="auto">
</mat-form-field>
<mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
  <mat-label>Request</mat-label>
  <textarea matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="5" 
            formControlName="request"></textarea>
            <mat-error  *ngIf="specialRequestForm.controls['request'].touched && specialRequestForm.controls['request'].hasError('required')">
              This is required field.
          </mat-error>
</mat-form-field>
      </div>
    </form>

     <!-- ***** Note Form ****** -->

    <form [formGroup]="noteForm" *ngIf="data.type === 'note'">
      <div class="inputprt">
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Note Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="New">New</mat-option>
            <mat-option value="Hold">Hold</mat-option>
            <mat-option value="Processing">Processing</mat-option>
            <mat-option value="Completed">Completed</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Assigned</mat-label>
          <input
            type="text"
            placeholder="Assigned"
            aria-label="Assigned"
            matInput
            formControlName="assigned"
          />
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Agreement Number</mat-label>
          <input
            matInput
            placeholder="Agreement Number"
           formControlName="agreementNumber"
          />
          <mat-error> This is required field. </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Priority</mat-label>
          <mat-select formControlName="priority">
            <mat-option value="Low">Low</mat-option>
            <mat-option value="Medium">Medium</mat-option>
            <mat-option value="High">High</mat-option>
            <mat-option value="Critical">Critical</mat-option>
          </mat-select>
          <mat-error> This is required field. </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
          <mat-label>Notes</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="5"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="5"
            formControlName="notes"
          ></textarea>
        </mat-form-field>
      </div>
    </form>

    <form [formGroup]="urgentTaskForm" *ngIf="data.type === 'urgentTask'">
      <div class="inputprt">
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Status</mat-label>
          <input
            type="text"
            placeholder="Status"
            aria-label="Status"
            matInput
            formControlName="status"
          />
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Created At</mat-label>
          <input
            type="text"
            placeholder="Created At"
            aria-label="Created At"
            matInput
            formControlName="createdAt"
          />
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Agent Name</mat-label>
          <input
            type="text"
            placeholder="Agent Name"
            aria-label="Agent Name"
            matInput
            formControlName="agentName"
          />
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Email Address</mat-label>
          <input
            type="text"
            placeholder="Email Address"
            aria-label="Email Address"
            matInput
            formControlName="emailAddress"
          />
        </mat-form-field>
       
        <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
          <mat-label>Note</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="5"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="5"
            formControlName="note"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
    <!-- <div
      class="actions"
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="8px"
    >
      <button mat-button type="button" class="sub-button">
        <span>Submit</span>
      </button>
      <button mat-button type="button" class="can-button" (click)="close()">
        <span>Cancel</span>
      </button>
    </div> -->
  </div>
</div>
